import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parentheses',
  standalone: true,
})
export class ParenthesesPipe implements PipeTransform {
  transform(value: string | number): string {
    if (value) {
      return `<span class="jip-parentheses ms-1">(<span class="wrap-value">${value}</span>)</span>`;
    } else {
      return '';
    }
  }
}
